'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  return typeof Object.getOwnPropertyDescriptors === 'function' ? Object.getOwnPropertyDescriptors : implementation;
};